import { render } from "./NotificationRequest.vue?vue&type=template&id=3cfc9e58"
import script from "./NotificationRequest.vue?vue&type=script&lang=js"
export * from "./NotificationRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__